import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import Footer from './Footer';

function PageWrapper(props) {
  const { children, className, ...passthroughProps } = props;
  return (
    <div className={className}>
      <Header {...passthroughProps} />
      <div id="mainContent" tabIndex="-1">
        { children }
      </div>
      <Footer {...passthroughProps} />
    </div>
  );
}

PageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

PageWrapper.defaultProps = {
  className: undefined,
};

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js